// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EPO_k{padding:0 24px}.S1g3L{position:absolute;bottom:24px;left:16px;right:16px}.XvrlZ{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textContent": `EPO_k`,
	"ctaWrapper": `S1g3L`,
	"ctaButton": `XvrlZ`
};
export default ___CSS_LOADER_EXPORT___;
